import { PaymentPayee } from '../model/tsp.types'

export const checkIsWithPercentFee = (payee: PaymentPayee): boolean => {
  const { customParams } = payee

  return Boolean(customParams && 'isWithPercentFee' in customParams && customParams.isWithPercentFee)
}
